<template>
	<div>
		<Card>
			<StrapiList source="/users">
				<template v-slot="list">
					<AdminAccountsTable v-bind="list" />
				</template>
			</StrapiList>
		</Card>
		<div class="actions">
			<router-link class="actions__btn" :to="addPage">Add account</router-link>
		</div>
	</div>
</template>

<script>
import Card from '@/components/shared/Card'
import StrapiList from '@/components/admin/StrapiList'
import AdminAccountsTable from '@/components/admin/AdminAccountsTable'

export default {
	name: 'ManageAccounts',
	data() {
		return {
			addPage: { name: 'Create Admin Account' }
		}
	},
	components: {
		Card,
		StrapiList,
		AdminAccountsTable
	}
}
</script>

<style lang="scss" scoped>
@import '~scss/components';

.actions {
	margin-top: 2rem;
	text-align: right;

	&__btn {
		@include button;
	}
}
</style>
